import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import db from '@/firebase/init';
import moment from 'moment';
// import { shortId } from '@/utils';

const state = () => ({
  today: moment(),
  weekDocs: {},  // weekString ("YYYY-W") to week doc {id: firebaseId, data: week}
})

const getters = {

  getToday: (state) => () => {
    return state.today;
  },

  getWeekDoc: (state) => (weekString) => {
    // weekString is "YYYY-W"
    return state.weekDocs[weekString];
  },

  getNumberOfTasks: (state, getters) => (weekString) => {
    let data = getters.getWeekDoc(weekString).data;
    let n = 0;
    for (var i = 0; i < data.days.length; i++) {
      n += data.days[i].tasks.length;
    }
    return n;
  },

}

const actions = {

  //let weekString = _moment.format("YYYY-W");
  fetchWeek(context, {weekString}) {
    // console.log("Executing loadWeek")
    let user = firebase.auth().currentUser
    db.collection('weeks')
      .where("userId", "==", user.uid)
      .where("week", "==", weekString)
      .get()
      .then((snapshot) => {
        let week;
        if (snapshot.empty) {
          week = {
            id: null,  // will be set on save
            data: {
              week: weekString,
              userId: user.uid,
              days: [
                {tasks: []},
                {tasks: []},
                {tasks: []},
                {tasks: []},
                {tasks: []},
                {tasks: []},
                {tasks: []},
              ]
            }
          };
        } else {
          snapshot.forEach(doc => {
            week = {
              id: doc.id,
              data: doc.data(),
            }
          });
        }
        context.commit('setWeek', {weekString, week});
      })
      .catch((err) => {
        console.log(`Error fetching week ${weekString}:`, err)
      })
  },

  saveWeek(context, {weekString}) {
    // Save week to firebase or delete if no tasks in week
    // console.log("Executing saveWeek")
    let weekDoc = context.getters.getWeekDoc(weekString);
    if (context.getters.getNumberOfTasks(weekString) > 0) {
      // save week if it has tasks
      let weekRef;
      if (weekDoc.id) {
        weekRef = db.collection('weeks').doc(weekDoc.id);
      } else {
        weekRef = db.collection('weeks').doc();
      }
      weekRef.set(weekDoc.data)
        .then(() => {
            context.commit('editWeek', {weekDoc, key: 'id', value: weekRef.id});
            console.log(`Week ${weekString} successfully saved!`);
        })
        .catch(function(error) {
            console.error("Error setting Week: ", error);
        });
    } else {
      // delete week if it has no tasks
      if (weekDoc.id) {
        let weekRef = db.collection('weeks').doc(weekDoc.id);
        weekRef.delete().then(function() {
            console.log(`Week ${weekString} successfully deleted!`);
        }).catch(function(error) {
            console.error(`Error removing Week ${weekString}: `, error);
        });
      }
    }
  }

}

const mutations = {

  // weeks
  setWeek(state, {weekString, week}) {
    Vue.set(state.weekDocs, weekString, week);
  },
  editWeek(state, {weekDoc, key, value}) {
    Vue.set(weekDoc, key, value);
  },

  // day objects
  editDayObject(state, {dayObject, key, value}) {
    Vue.set(dayObject, key, value);
  },

  // tasks
  addTask(state, {dayObject, position, task}) {
    dayObject.tasks.splice(position, 0, task);
  },
  editTask(state, {task, key, value}) {
    Vue.set(task, key, value);
  },
  removeTask(state, {dayObject, position}) {
    dayObject.tasks.splice(position, 1);
  },

  // today

  updateToday(state) {
    Vue.set(state, "today", moment())
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
